import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Loader from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import CircularButton from "../CircularButton/CircularButton";
import resetOrientation from "reset-image-orientation";
import InputText from "../InputText/InputText";
import Button from "../Button/Button";
import YoutubeVideo from "../YoutubeVideo/YoutubeVideo";

const onChange = (setUploading, setImageUrl, e, folder) => {
  setUploading(true);
  let filename = "";
  let contentType = "";
  let upFile = e.target.files[0];
  filename = upFile.name;
  contentType = upFile.type;
  if (contentType === "image/jpeg" || contentType === "image/jpg") {
    resetOrientation(e.target.files[0], base64 => {
      var base64EncodedImageString = base64.replace(
        /^data:image\/\w+;base64,/,
        ""
      );
      var imageBuffer = new Buffer(base64EncodedImageString, "base64");
      return fetch(
        "https://us-central1-kids-qualitytime.cloudfunctions.net/upload_file/url",
        {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: JSON.stringify({
            filename,
            contentType,
            folder
          })
        }
      )
        .then(res => res.json())
        .then(res => {
          return fetch(res.url, {
            method: "PUT",
            headers: {
              "Content-Type": contentType
            },
            body: imageBuffer
          })
            .then(r => {
              setImageUrl(res.publicUrl, contentType, filename);
              setUploading(false);
              return true;
            })
            .catch(error => {
              console.error(error);
              setUploading(false);
              return false;
            });
        });
    });
  } else {
    return fetch(
      "https://us-central1-kids-qualitytime.cloudfunctions.net/upload_file/url",
      {
        method: "POST",
        headers: {
          Accept: "application/json"
        },
        body: JSON.stringify({
          filename,
          contentType,
          folder
        })
      }
    )
      .then(res => res.json())
      .then(res => {
        return fetch(res.url, {
          method: "PUT",
          headers: {
            "Content-Type": contentType
          },
          body: upFile
        })
          .then(r => {
            setImageUrl(res.publicUrl, contentType, filename);
            setUploading(false);
            return true;
          })
          .catch(error => {
            console.error(error);
            setUploading(false);
            return false;
          });
      });
  }
};

const ImageLabel = styled.label`
  height: 50px;
  line-height: 46px;
  box-sizing: border-box;
  border: 2px solid #bfbfbf;
  color: #7d7d7d;
  background: 0 0;
  border-radius: 25px;
  cursor: pointer;
  float: right;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 10px;
  svg {
    width: 30px;
    height: 24px;
    display: block;
    float: left;
    margin: 12px 14px 0 18px;
  }
`;

const ImageLabelText = styled.span`
  display: block;
  color: #353535;
  font-weight: 600;
  font-size: 20px;
`;

const Input = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const EditLabel = styled.label`
  position: absolute;
  right: -10px;
  top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  button {
    border: 0px solid;
  }
`;

const Title = styled.div`
  width: 100%;
`;

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px;
  flex-direction: column;
  position: relative;
  min-height: ${props => (props.notImage ? "0" : "110px")};
  img {
    width: 100%;
  }
  textarea {
    font-size: 18px;
    outline: none;
    width: 100%;
  }
`;

const AddImage = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  margin: 0;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-border-radius: 3px;
  border-radius: 3px;
`;

const AddImageContainer = styled.div`
  background-color: #fff;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 0 3px 3px;
`;

const FullPageDiv = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  background: white;
  z-index: 100;
  padding: 20px;
  .imageDescription {
    width: 100%;
    font-size: 16px;
    border: none;
    padding: 0;
    line-height: 20px;
    outline: none;
    ::placeholder {
      color: ${props => props.theme.borderColor};
    }
  }
  .imageTitle {
    margin-top: 20px;
    overflow: hidden;
    resize: none;
    height: 40px;
    font-weight: 700;
    font-size: 24px;
    outline: none;
    width: 100%;
    border: none;
    resize: none;
    padding: 0;
    ::placeholder {
      color: ${props => props.theme.borderColor};
    }
  }
`;

const DeleteContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
const TopPanel = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  button {
    background: transparent;
  }
`;
const Panel = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;
export default withTheme(
  ({
    folder,
    image,
    onUpload,
    onLoading,
    theme,
    id,
    noEdit,
    content = {},
    setContent,
    type
  }) => {
    const [imageUrl, setImageUrl] = useState(image ? image : "");
    const [uploading, setUploading] = useState(false);
    const [editmode, setEditmode] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    if (deleteConfirm) {
      return (
        <FullPageDiv>
          <DeleteContent>
            <label>Are you sure, you want to delete the image?</label>
            <Panel>
              <Button
                inverted
                onClick={() => {
                  setDeleteConfirm(false);
                  setEditmode(true);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setDeleteConfirm(false);
                  setContent(null);
                }}
              >
                Delete
              </Button>
            </Panel>
          </DeleteContent>
        </FullPageDiv>
      );
    }
    if (editmode) {
      return (
        <FullPageDiv>
          <TopPanel>
            <button onClick={() => setEditmode(false)}>
              <FontAwesomeIcon
                icon={["fas", "times"]}
                size="2x"
                color={theme.fontColor}
              />
            </button>
          </TopPanel>
          <Title>
            <textarea
              className="imageTitle"
              placeholder={"Image title..."}
              value={content.title}
              onChange={e => setContent({ ...content, title: e.target.value })}
            />
          </Title>
          <textarea
            className="imageDescription"
            placeholder="Tell us about this image..."
            value={content.description}
            rows={(content.description || "").split("\n").length}
            onChange={e => {
              setContent({ ...content, description: e.target.value });
            }}
          />
          <div style={{ flexGrow: 1 }} />
          <Title>
            <label>Image source</label>
            <InputText
              placeholder={"Not your image? Add a link..."}
              value={content.title}
              onChange={e => setContent({ ...content, source: e.target.value })}
            />
          </Title>
          <Panel>
            <Button
              onClick={() => {
                setDeleteConfirm(true);
                setEditmode(false);
              }}
            >
              Delete
            </Button>
          </Panel>
        </FullPageDiv>
      );
    }
    if (uploading) {
      return <Loader />;
    }
    const theId = id || "single";
    return (
      <Root>
        {(!imageUrl || noEdit) && (
          <Input
            type="file"
            id={theId}
            onChange={e =>
              onChange(
                v => {
                  setUploading(v);
                  if (onLoading) {
                    onLoading(v);
                  }
                },
                (url, contentType, filename) => {
                  setImageUrl(url);
                  var img = new Image();
                  img.src = url;
                  if (onUpload) {
                    img.onload = function() {
                      var height = img.height;
                      var width = img.width;
                      onUpload(url, width, height, contentType, filename);
                    };
                  }
                },
                e,
                folder
              )
            }
          />
        )}
        {(!imageUrl || noEdit) && (
          <AddImageContainer>
            <AddImage>
              <ImageLabelText>Add images here</ImageLabelText>
              <ImageLabel htmlFor={theId} for={theId}>
                <FontAwesomeIcon
                  icon={["fas", "upload"]}
                  size="2x"
                  color={theme.borderColor}
                />
                Upload Photo
              </ImageLabel>
            </AddImage>
          </AddImageContainer>
        )}
        {imageUrl && !noEdit && (
          <EditLabel>
            <CircularButton
              icon="pen"
              onClick={() => {
                setEditmode(true);
              }}
            />
          </EditLabel>
        )}
        {imageUrl && !noEdit && (
          <Title>
            <textarea
              placeholder={"Image title..."}
              value={content.title}
              onChange={e => setContent({ ...content, title: e.target.value })}
            />
          </Title>
        )}
        {type !== "video" && imageUrl && !noEdit && <img src={imageUrl} />}
        {type === "video" && imageUrl && !noEdit && (
          <YoutubeVideo videoLink={imageUrl} readonly />
        )}
        {imageUrl && !noEdit && (
          <textarea
            value={content.description}
            rows={(content.description || "").split("\n").length}
            onChange={e => {
              setContent({ ...content, description: e.target.value });
            }}
          />
        )}
      </Root>
    );
  }
);
